
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/legal/privacy/2023-05-15",
      function () {
        return require("private-next-pages/[locale]/legal/privacy/2023-05-15.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/legal/privacy/2023-05-15"])
      });
    }
  